

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Category from '@/components/Commons/Category.vue';
@Component({
  components: {
    Category,
  },
})
export default class SubCategory extends Vue {
  mounted() {
    vxm.skills.fetchCategoryDetails(this.$route.params.id);
  }

  get categoryDetails() {
    return vxm.skills.CategoryDetails;
  }

  onSelectCategory(category) {
    let filterConfig = vxm.jobs.searchFilterObj;
    filterConfig.categories = [category.categoryId];
    vxm.jobs.setSearchFilterObj(filterConfig);
    this.$router.push({ name: 'Findjobs' });
  }
}
